import type { ChatSession } from '@/types/api';

export interface SessionGroup {
  label: 'Today' | 'Yesterday' | 'Previous 7 days' | 'Older';
  sessions: ChatSession[];
}

const ORDER: SessionGroup['label'][] = ['Today', 'Yesterday', 'Previous 7 days', 'Older'];

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

function bucketFor(lastMessageAt: string | null): SessionGroup['label'] {
  if (!lastMessageAt) return 'Older';
  const today = startOfDay(new Date());
  const day = startOfDay(new Date(lastMessageAt));
  const diffDays = Math.round((today - day) / 86_400_000);
  if (diffDays <= 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays <= 7) return 'Previous 7 days';
  return 'Older';
}

/** Group sessions into time buckets, newest-first within each, empty buckets omitted. */
export function groupSessionsByTime(sessions: ChatSession[]): SessionGroup[] {
  const map = new Map<SessionGroup['label'], ChatSession[]>();
  const sorted = [...sessions].sort((a, b) => {
    const ta = a.last_message_at ? Date.parse(a.last_message_at) : 0;
    const tb = b.last_message_at ? Date.parse(b.last_message_at) : 0;
    return tb - ta;
  });
  for (const s of sorted) {
    const label = bucketFor(s.last_message_at);
    if (!map.has(label)) map.set(label, []);
    map.get(label)!.push(s);
  }
  return ORDER.filter((l) => map.has(l)).map((label) => ({ label, sessions: map.get(label)! }));
}
